import { Navigate } from 'react-router-dom';

/** Kept so old `/attributions` links land on the Terms attributions section. */
export default function Attributions() {
  return <Navigate to="/terms#attributions" replace />;
}
